import React from 'react'

import { Button } from '@/components/ui/button'
import { useTheme } from '@/context/ThemeContext'

type SuggestedTopic = {
  id: string
  text: string
}

interface SuggestedTopicsProps {
  topics: SuggestedTopic[]
  onSelectTopic: (topic: string) => void
}

const SuggestedTopics: React.FC<SuggestedTopicsProps> = ({ topics, onSelectTopic }) => {
  const { isDarkMode } = useTheme()

  if (topics.length === 0) return null

  return (
    <div className="mb-6">
      <div className="flex flex-wrap justify-center gap-2">
        {topics.map((topic) => (
          <Button
            key={topic.id}
            variant="outline"
            className={`
              text-sm px-3 py-1 h-auto rounded-full relative gradient-border-animation
              ${
                isDarkMode
                  ? 'bg-gray-800 hover:bg-gray-700 border-gray-700 text-gray-200'
                  : 'bg-white hover:bg-gray-50 border-gray-200 text-gray-800'
              }
            `}
            onClick={() => onSelectTopic(topic.text)}
          >
            {topic.text}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default SuggestedTopics
